class TradingSettings {
	constructor() {
        this.tradingContracts = {};
        this.mainContracts = {
            'EURUSD': true,
            'GBPUSD': true,
            'USDCHF': true,
            'USDJPY': true,
            'USDRUB': true,
            'EURRUB': true,
            'BTCUSD': true,
            'ETHUSD': true,
            'NZDUSD': true,
            'AUDUSD': true
        }
    }

    isMainTicker(symbol) {
    	return this.mainContracts[symbol] ? true : false;
    }

    getMainContracts() {
        let names = [];
        for (let key in this.mainContracts)
            names.push(key);
        return names;
    }
}

export let tradingSettings = new TradingSettings();